import type { IUser } from '~/models';
import { WorkerClassificationTypeEnum } from '~/models/WorkerClassification';

/**
 * Whether an office must accept the Personnel Service Agreement before it posts: its worker type is
 * confirmed employee and its PSA is not accepted. A record without either field is unknown rather than
 * missing and asks for nothing; the server's refusal at posting still opens the popup for it.
 */
export const needsPsa = (office: Pick<IUser, 'workerClassification' | 'office_info'>): boolean =>
  office.workerClassification?.classificationType === WorkerClassificationTypeEnum.Employee &&
  office.office_info?.psaTerms?.accepted === false;
